<template lang="pug">
div
  h2 Cancel Booking
  p Are you sure you wish to cancel booking {{ booking.Number }}?
  .actions
    BriqButton.mr-XXS(variant="text" :disabled="loading" @click="close") Cancel
    BriqButton.ml-XXS(@click="onConfirm" :disabled="loading" variant='red') Cancel Booking
</template>

<script>
export default {
  name: 'CancelBookingDialog',
  props: {
    booking: Object
  },
  data() {
    return {
      loading: false
    }
  },
  methods: {
    async onConfirm() {
      this.loading = true
      const res = await this.$store.dispatch('bookings/cancelBooking', this.booking.Key)
      if (res.status === 200) {
        this.$notifySuccess(`Booking ${this.booking.Number} has been cancelled.`)
        setTimeout(() => {
          this.loading = false
          this.close()
          this.$emit("reloadBookings")
        }, 2000);
      } else {
        this.$notifySuccess(`Unable to cancel booking ${this.booking.Number}. Please try again later.`)
        this.loading = false
      }
    },
    close() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="stylus">
.actions
  display: flex;
  justify-content: center;
  align-content: center;
  margin-top: 12px;
</style>
